import { Injectable, } from '@angular/core';
import { catchError, map, retry } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClientModule,HttpHeaders,HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';


@Injectable({
	providedIn: 'root'
})

export class VendorService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';

	constructor(private globalSearchService: GlobalSearchService, private http: HttpClient,private _configSvc: RuntimeConfigLoaderService) {
		this.globalSearchService.user.subscribe((result: any) => {
			this.user = result;
		});

		this.globalSearchService.configsubscription.subscribe((result: any) => {
			this.config = result;
		});
	}


	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type':	'application/json',
		})
	};


	public vendorService(id: any) {

	}

	public searchVendorHistory(data: any) {
		const method = 'vendor/history';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getAge() {
		const method = 'vendor/ageing';
		return this.http.get(this.setEndPoint(method));
	}

	public getDashBoard() {
		const method = 'vendor/dashboard';
		return this.http.get(this.setEndPoint(method));
	}

	public getTop100Vendors(data: any) {
		const method = 'vendor/top100';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public checkInvoiceReference(supplierid: string, reference: string) {
		const method = 'vendor/invoice/checkreference&supplierid=' + encodeURIComponent(supplierid) + '&reference=' + encodeURIComponent(reference);
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public checkCreditReference(supplierid: string, reference: string) {
		const method = 'vendor/credit/checkreference&supplierid=' + encodeURIComponent(supplierid) + '&reference=' + encodeURIComponent(reference);
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public createInvoice(invoicedata: any) {
		const method = 'vendor/invoice/create';
		return this.http.post(this.setEndPoint(method), invoicedata, this.httpOptions).pipe(
			catchError(this.handleError(method, invoicedata))
		);
	}

	public createCredit(data: any) {
		const method = 'vendor/credit/create';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public createReturn(data: any) {
		const method = 'vendor/return/create';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public updateVendorContacts(settings: any) {
		const method = 'vendor/updatevendorcontacts';
		return this.http.post(this.setEndPoint(method), settings, this.httpOptions).pipe(catchError(this.handleError(method, settings))
		);
	}
	public updateVendorNotes(settings: any) {
		const method = 'vendor/updatenotes';
		return this.http.post(this.setEndPoint(method), settings, this.httpOptions).pipe(catchError(this.handleError(method, settings))
		);
	}

	public updateVendor(input: any) {
		const method = 'vendor/update';
		return this.http.post(this.setEndPoint(method), { vendordata: input }, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getVendor(vendorid: any) {
		const method = 'vendor/read&supplierid='+vendorid;
		return this.http.get(this.setEndPoint(method));
	}

	public getVendorTransactions(data: any) {
		const method = 'vendor/transactions';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public reverseTransaction(transid: any, reason: any) {
		const method = 'purchasing/reversal';
		return this.http.post(this.setEndPoint(method), { transid: transid, reason: reason }, this.httpOptions).pipe(
			catchError(this.handleError(method, { transid: transid }))
		);
	}

	public getDailyTransactions(data: any) {
		const method = 'vendor/getdailytransactions';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('vendor/getdailytransactions', data))
		);
	}

	public getVendors() {
		const method = 'vendor/search';
		return this.http.get(this.setEndPoint(method));
	}
	public getVendorsPost(data) {
		const method = 'vendor/search';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getVendorSearch(keywords: any) {
		const method = 'vendor/search&keywords='+keywords;
		return this.http.get(this.setEndPoint(method));
	}

	public getVendorTypes() {
		const method = 'vendor/getvendortypes';
		return this.http.get(this.setEndPoint(method));
	}

	public getInactiveType() {
		const method = 'vendor/getinactivetype';
		return this.http.get(this.setEndPoint(method));
	}

	public getVendorItems(vendorid){
		 const method = 'vendor/purchdata&supplierid='+vendorid;
		 return this.http.get(this.setEndPoint(method));
	}

	public deleteVendor(vendorid){
		 const method = 'vendor/remove&supplierid='+vendorid;
		 return this.http.get(this.setEndPoint(method));
	}

	public saveVendor(vendordata){
		const method = 'vendor/save';
		return this.http.post(this.setEndPoint(method), { vendordata: vendordata }, this.httpOptions).pipe(
			catchError(this.handleError(method, vendordata))
		);
	}

	public uploadVendorAttachment(transId: number, payload: { content: string; name: string; mime: string }) {
		const method = 'vendor/attachment/upload';
		const body = { ...payload, transid: transId };
		const options = { ...this.httpOptions, timeout: 120000 };
		return this.http.post(this.setEndPoint(method), body, options).pipe(
			map((res: any) => {
				if (res && res.success !== true) {
					throw new Error('Attachment upload failed');
				}
				return res;
			}),
			catchError(this.handleError(method, body))
		);
	}

	public getVendorAttachments(transId: number) {
		const method = 'vendor/attachment/getList&transid=' + transId;
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public getVendorAttachmentDownloadUrl(attachmentId: number): string {
		return this.getApi() + 'vendor/attachment/download&id=' + attachmentId + this.getApiKey();
	}

	public getVendorAttachmentViewUrl(attachmentId: number): string {
		return this.getApi() + 'vendor/attachment/download&id=' + attachmentId + '&inline=1' + this.getApiKey();
	}

	public uploadVendorDocument(supplierid: string, payload: { content: string; name: string; mime: string }) {
		const method = 'vendor/documents/upload';
		const body = { ...payload, supplierid };
		return this.http.post(this.setEndPoint(method), body, this.httpOptions).pipe(
			catchError(this.handleError(method, body))
		);
	}

	public getVendorDocuments(supplierid: string) {
		const method = 'vendor/documents/list&supplierid=' + encodeURIComponent(supplierid);
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public deleteVendorDocument(supplierid: string, idOrLink: number | string) {
		const method = 'vendor/documents/delete';
		const body = typeof idOrLink === 'number'
			? { id: idOrLink, supplierid }
			: { supplierid, link: idOrLink };
		return this.http.post(this.setEndPoint(method), body, this.httpOptions).pipe(
			catchError(this.handleError(method, body))
		);
	}

	private setEndPoint(method: any) {
		return this.getApi()+method+this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey='+this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			return throwError(() => error);
		};
	}
}
